import { render, staticRenderFns } from "./integrlist.vue?vue&type=template&id=450a2f34"
import script from "./integrlist.vue?vue&type=script&lang=js"
export * from "./integrlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports